<!-- 板子层数 -->
<template>
  <BaseFormItem2
    :label="fields.label"
    :labelTips="fields.labelTips"
  >
    <BaseRadioGroup2 v-model="val" @change="handleEmit">
      <el-radio-button
        v-for="item in options"
        :key="item.value"
        :label="item.value"
        :disabled="item.disabled"
      >{{ item.label }}</el-radio-button>
    </BaseRadioGroup2>
  </BaseFormItem2>
</template>

<script>
import { getCOPPERFields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: [String, Number],
      default: 2
    },
    // 铜基板结构
    copper_board_type: {
      type: [String, Number],
      default: ''
    },
    // 返回修改初始化参数时，参数不进行关联变更
    initPcbParamsChange: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: +this.value
    }
  },
  computed: {
    fields() {
      return getCOPPERFields('blayer')
    },
    options() {
      const { fields, copper_board_type, val } = this
      let options = fields.options

      // 铜基板结构 为 芯板为铜基,顶底层为走线 时，禁用 1, 6, 8
      const disabledOptions = copper_board_type == 2 ? [1, 6, 8] : []

      // 如果当前项被禁用
      if (disabledOptions.includes(val)) {
        this.changeVal(2)
      }
      
      return options.map(item => ({...item, disabled: disabledOptions.includes(item.value) }))
    }
  },
  watch: {
    value(newVal) {
      this.val = +newVal
    }
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.$emit('change', val)
    },
    changeVal(val) {
      if (this.initPcbParamsChange) return
      this.$topWarning.mergeFields(this.fields.label)
      this.val = val
      this.handleEmit()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>